<div class="secure-layout">
  <pl-header [navigation]="navigation"></pl-header>
  <div class="secure-layout__body">
    <pl-navigation
      [pages]="navPages"
      [resources]="navResources"
      [currentUrl]="currentUrl"
    >
      <ng-template #helpMenuContent>
        <pl-help-menu
          [links]="helpMenuLinks"
          [emails]="helpMenuEmails"
          [version]="version"
          (linkClicked)="onHelpLinkClicked($event)"
        />
      </ng-template>
    </pl-navigation>
    <main class="secure-layout__content">
      <pl-banner
        *ngIf="
          banner.activeShellBanner() === 'media_permissions' && !isImpersonating
        "
        type="info"
        title="Enable audio and camera access in your Room"
        body="Review your permissions before your next session to help avoid disruptions."
        primaryButtonLabel="Head to your room"
        [showCloseButton]="true"
        class="d-block mt-2 mt-md-4 mx-2 mx-md-4"
        (primaryClicked)="onMediaPermissionsHeadToRoom()"
        (closeClicked)="onMediaPermissionsDismiss()"
      ></pl-banner>
      <div *ngIf="layout?.title" class="title-bar pt-2 pt-md-4 px-2 px-md-4">
        <div class="mb-3 d-flex align-items-center">
          <h1 class="title">{{ layout?.title }}</h1>
        </div>
      </div>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
